<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Load Credit'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
    <tidy-row>
      <div>

        @if (!loaded) {
          <tidy-card>
            <ion-skeleton-text
              animated="true"
              style="width: 100%; height: 45px; border-radius: 6px; margin-bottom: 1rem" />
            <ion-skeleton-text
              animated="true"
              style="width: 100%; height: 45px; border-radius: 6px; margin-bottom: 1rem" />
          </tidy-card>
          <ion-skeleton-text
            animated="true"
            style="width: 100%; height: 60px; border-radius: 6px; margin-bottom: 1rem" />
        }

        @if (loaded) {
          <!-- Section 1: Credit Card/ACH Debit -->
          <tidy-row style="margin-bottom: 0.5rem">
            <tidy-text [title]="'Credit Card/ACH Debit'" />
          </tidy-row>
          <tidy-row style="margin-bottom: 1rem">
            <tidy-text [body]="'Load credit from your credit card or ACH debit (we pull from your bank).'" />
          </tidy-row>

          @if (paymentMethodsItems.length === 1) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Please add a payment method to load credit.'" />
            </tidy-row>
            <tidy-button
              [text]="'Add Payment Method'"
              [action]="boundGoToAddPaymentMethod"
              class="primary" />
          }

          @if (paymentMethodsItems.length > 1) {
            <tidy-card>
              <form [formGroup]="form">
                <tidy-row>
                  <tidy-select
                    [icon]="'assets/svg/card.svg'"
                    [multiple]="false"
                    [label]="'Payment Method'"
                    [items]="paymentMethodsItems"
                    [form]="form.controls.paymentMethod"
                    formControlName="paymentMethod"
                    class="select-custom-input select-custom-input-bigger"
                    (optionChange)="changePaymentMethod($event)" />
                </tidy-row>
                <tidy-row>
                  <tidy-input
                    formControlName="price"
                    [label]="'Amount'"
                    [form]="form.controls.price"
                    [icon]="'assets/svg/card.svg'"
                    [errorMessage]="'Please select an amount.'"
                    [submitted]="submitted"
                    inputMode="numeric"
                    [mask]="'currencyMask'"
                    class="select-custom-input select-custom-input-bigger" />
                </tidy-row>
              </form>
            </tidy-card>
            <tidy-button
              [text]="'Add Credit'"
              [action]="boundAddCredit"
              class="primary" />
          }

          <!-- Section 2: ACH/Wire In -->
          <tidy-row style="margin-top: 2rem; margin-bottom: 0.5rem">
            <tidy-text [title]="'ACH/Wire In'" />
          </tidy-row>
          <tidy-row style="margin-bottom: 1rem">
            <tidy-text [body]="'Transfer funds in to save on processing fees (tidy.com/pricing).'" />
          </tidy-row>

          <tidy-card>
            <tidy-row style="margin-bottom: 0.75rem">
              <tidy-text [header]="'Routing (for wire and ACH both):'" />
            </tidy-row>
            <tidy-row style="margin-bottom: 1rem">
              <tidy-text [body]="'121145433'" class="monospace-text" />
            </tidy-row>

            <tidy-row style="margin-bottom: 0.75rem">
              <tidy-text [header]="'Account:'" />
            </tidy-row>
            <tidy-row style="margin-bottom: 1rem">
              <tidy-text [body]="'480082106298026'" class="monospace-text" />
            </tidy-row>

            <tidy-row style="margin-bottom: 0.75rem">
              <tidy-text [header]="'IMPORTANT:'" />
            </tidy-row>
            <tidy-row style="margin-bottom: 1rem">
              <tidy-text [body]="'Include the owner\'s email address or your customer ID (get from support) in the description so we can apply it to your account.'" />
            </tidy-row>

            <!-- More Info Dropdown -->
            <tidy-row>
              <div class="more-info-toggle" (click)="toggleMoreInfo()">
                <tidy-text [header]="'More Info'" />
                <ion-icon [name]="showMoreInfo ? 'chevron-up' : 'chevron-down'" style="margin-left: 8px" />
              </div>
            </tidy-row>

            @if (showMoreInfo) {
              <div class="more-info-content">
                <tidy-row style="margin-bottom: 0.75rem; margin-top: 1rem">
                  <tidy-text [header]="'Recipient:'" />
                </tidy-row>
                <tidy-row style="margin-bottom: 1rem">
                  <tidy-text [body]="'Tidy Services, Inc.'" />
                </tidy-row>

                <tidy-row style="margin-bottom: 0.75rem">
                  <tidy-text [header]="'Recipient Address:'" />
                </tidy-row>
                <tidy-row style="margin-bottom: 1rem">
                  <tidy-text [body]="'2093 PHILADELPHIA PIKE #1446\nClaymont DE 19703\nUnited States'" />
                </tidy-row>

                <tidy-row style="margin-bottom: 0.75rem">
                  <tidy-text [header]="'Bank:'" />
                </tidy-row>
                <tidy-row style="margin-bottom: 1rem">
                  <tidy-text [body]="'Column N.A.'" />
                </tidy-row>

                <tidy-row style="margin-bottom: 0.75rem">
                  <tidy-text [header]="'Bank Address:'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [body]="'1 Letterman Drive, Building A, Suite A4-700, San Francisco, CA 94129'" />
                </tidy-row>
              </div>
            }
          </tidy-card>
        }

        <!-- <tidy-row style="margin-bottom: 1rem">
        <tidy-text [title]="'Credit History'"></tidy-text>
      </tidy-row>

      <ng-container *ngIf="!loaded">
        <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]; trackBy: trackByIndex">
          <tidy-card>
            <ion-skeleton-text
              animated="true"
              style="width: 120px; height: 30px; border-radius: 6px">
            </ion-skeleton-text>
            <div style="margin-top: 1rem"></div>
            <div class="vertical-align-center justify-content-between" style="margin-bottom: -1rem">
              <div style="width: 48%">
                <ion-skeleton-text
                  animated="true"
                    style="
                      width: 100%;
                      height: 28px;
                      border-radius: 6px;
                      margin-bottom: 2rem;
                    ">
                </ion-skeleton-text>
              </div>
              <div style="width: 50%; margin-left: 1rem">
                <ion-skeleton-text
                  animated="true"
                    style="
                      width: 100%;
                      height: 28px;
                      border-radius: 6px;
                      margin-bottom: 2rem;
                    ">
                </ion-skeleton-text>
              </div>
            </div>
            <ion-skeleton-text
              animated="true"
              style="width: 60%; height: 25px; border-radius: 6px">
            </ion-skeleton-text>
            <ion-skeleton-text
              animated="true"
              style="width: 40%; height: 25px; border-radius: 6px">
            </ion-skeleton-text>
          </tidy-card>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!loadedNewCredit">
        <ng-container>
          <tidy-card>
            <ion-skeleton-text
              animated="true"
              style="width: 120px; height: 30px; border-radius: 6px">
            </ion-skeleton-text>
            <div style="margin-top: 1rem"></div>
            <div class="vertical-align-center justify-content-between" style="margin-bottom: -1rem">
              <div style="width: 48%">
                <ion-skeleton-text
                  animated="true"
                    style="
                      width: 100%;
                      height: 28px;
                      border-radius: 6px;
                      margin-bottom: 2rem;
                    ">
                </ion-skeleton-text>
              </div>
              <div style="width: 50%; margin-left: 1rem">
                <ion-skeleton-text
                  animated="true"
                    style="
                      width: 100%;
                      height: 28px;
                      border-radius: 6px;
                      margin-bottom: 2rem;
                    ">
                </ion-skeleton-text>
              </div>
            </div>
            <ion-skeleton-text
              animated="true"
              style="width: 60%; height: 25px; border-radius: 6px">
            </ion-skeleton-text>
            <ion-skeleton-text
              animated="true"
              style="width: 40%; height: 25px; border-radius: 6px">
            </ion-skeleton-text>
          </tidy-card>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let credit of creditHistory; trackBy: trackByCredit">
        <tidy-card>
          <ng-container *ngIf="credit?.status">
            <tidy-row>
              <ion-chip [class]="credit?.class">
                <ion-icon [name]="credit?.icon"></ion-icon>
                <ion-label>{{ credit?.status | titlecase }}</ion-label>
              </ion-chip>
            </tidy-row>
          </ng-container>
          <div class="vertical-align-center justify-content-between">
            <div style="margin-bottom: 1rem">
              <tidy-image [src]="'assets/img/coin.png'" class="header-size">
              </tidy-image>
              <tidy-text [header]="'Amount added: '"></tidy-text>
              <tidy-text
                [body]="credit?.amount / 100 | currency"
              style="margin-left: 5px"></tidy-text>
            </div>
            <div>
              <tidy-text [header]="'Date: '"></tidy-text>
              <tidy-text
                [body]="credit?.date | parseDateTime: 'MMM d'"
              style="margin-left: 5px"></tidy-text>
            </div>
          </div>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="credit?.payment_method?.type === 'card' ? 'assets/svg/card.svg' : 'assets/img/bank.png'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="(credit?.payment_method?.type === 'card' ? ('Card' | translate) : ('Bank Account' | translate)) + (credit?.payment_method?.metadata?.last4 ? (' ending in ' | translate) + (credit?.payment_method?.metadata?.last4 | translate) : '')">
            </tidy-text>
            <ng-container *ngIf="credit?.payment_method?.is_primary">
              <tidy-text [header]="'(primary)'" style="margin-left: 5px">
              </tidy-text>
            </ng-container>
          </tidy-row>
          <ng-container *ngIf="credit?.payment_method?.metadata?.bank_name">
            <tidy-row style="margin-top: -15px">
              <tidy-text
                [body]="credit?.payment_method?.metadata?.bank_name + (credit?.payment_method?.metadata?.account_type ? ' | ' + (credit?.payment_method?.metadata?.account_type | translate) : '')">
              </tidy-text>
            </tidy-row>
          </ng-container>
        </tidy-card>
      </ng-container> -->
    </div>
  </tidy-row>
</tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
